/* @flow */

export default {
  root: {
    width: 15,
    height: 12,

    transformOrigin: 'center center',
  },
  'root-right': {
    transform: 'rotate(180deg)',
  },
  'root-up': {
    /* Translation is needed because icon is not square */
    transform: 'translate(-1.5px, 1.5px) rotate(90deg)',
  },
  'root-down': {
    /* Translation is needed because icon is not square */
    transform: 'translate(-1.5px, 1.5px) rotate(-90deg)',
  },
};
